import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import React from 'react';
import { DateFormat } from '../../settings';

const formatterRegex = /[^. ,[a-zA-Z0-9_]*$]+/gi;
const defaultMaxDateMessage = 'Future date not allowed.';

export default function DateInput({
  value,
  label,
  maxDateMessage,
  className,
  error,
  onChange,
  defaultToday,
  required,
  disableFuture,
  autoOk = true,
  autoExpand,
}) {
  const getValue = () => {
    if (defaultToday && !value) {
      const today = moment();
      setTimeout(() => onChange && onChange(today));
      return today;
    }
    return value;
  };

  const styles = autoExpand ? { minWidth: '130px' } : {};

  return (
    <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
      <KeyboardDatePicker
        autoOk={autoOk}
        required={required}
        disableFuture={disableFuture}
        format={DateFormat}
        rifmFormatter={(val) => val.replace(formatterRegex, '')}
        refuse={formatterRegex}
        rightArrowButtonProps={{ size: 'small' }}
        maxDateMessage={maxDateMessage || defaultMaxDateMessage}
        label={label}
        value={getValue()}
        className={className}
        error={error}
        onChange={onChange}
        style={styles}
      />
    </MuiPickersUtilsProvider>
  );
}
